module.exports = __webpack_public_path__ + "static/media/gray_11_2.5a936217.jpg";